<template>
  <div class="navbar_wrap hidden-xs-only">
    <div class="navbar_container">
      <div class="navbar_left">
        <img src="@/assets/img/home/logo.png" alt="晴天集团" />
      </div>
      <div class="navbar_right">
        <el-menu
          :default-active="activeIndex"
          class="el_menu_demo"
          mode="horizontal"
          background-color="rgba(0,0,0, 0)"
          :text-color="navBackground"
          :active-text-color="navActiveBackground"
          @select="changeCurrentPage"
        >
          <el-menu-item index="1" class="menu_item">{{$t("nav.home")}}</el-menu-item>
          <el-menu-item index="2" class="menu_item">{{$t("nav.about")}}</el-menu-item>
          <el-submenu index="3" class="menu_item">
            <template slot="title" >
              <span @click="changeCenterShow">{{$t("nav.portfolioCompanies")}}</span>
            </template>
            <el-menu-item index="3-1" class="menu_item">{{$t("nav.investOne")}}</el-menu-item>
            <el-menu-item index="3-2" class="menu_item">{{$t("nav.investTwo")}}</el-menu-item>
            <el-menu-item index="3-3" class="menu_item">{{$t("nav.investThree")}}</el-menu-item>
            <el-menu-item index="3-4" class="menu_item">{{$t("nav.investFour")}}</el-menu-item>
          </el-submenu>
          <el-menu-item index="4" class="menu_item">{{$t("nav.dynamic")}}</el-menu-item>
          <el-menu-item index="5" class="menu_item">{{$t("nav.proBono")}}</el-menu-item>
          <el-menu-item index="6" class="menu_item">{{$t("nav.contact")}}</el-menu-item>
          <el-submenu index="7">
            <template slot="title">GLOBAL</template>
            <el-menu-item index="7-1" class="menu_item" @click="switchLanguage('zh-CN')">简体</el-menu-item>
            <el-menu-item index="7-2" class="menu_item" @click="switchLanguage('zh-TW')">繁體</el-menu-item>
            <el-menu-item index="7-3" class="menu_item" @click="switchLanguage('en')">English</el-menu-item>
            <el-menu-item index="7-4" class="menu_item" @click="switchLanguage('ar')">بالعربية</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: this.selectIndex,
      navBackground:'#fff',
      navActiveBackground:'#fccc0c'
    }
  },
  props: {
    selectIndex: {
      type: String,
      default: '1',
    },
  },
  mounted() {
    this.activeIndex = this.selectIndex
    window.onscroll = () => {
      if(document.documentElement.scrollTop > 390){
        this.navBackground = '#000'
      }else{
        this.navBackground = '#fff'
      }
    }
  },
  methods: {
    changeCenterShow()
    {
      if(window.location.pathname !== "/portfolio-companies/0")
      {
        this.$router.push('/portfolio-companies')
      }
    },
    // 切换语言的方法
    switchLanguage(nextLang) {
      // 切换语言
      this.$i18n.locale = nextLang
      // 可以在此处添加保存语言偏好到本地存储的逻辑
      localStorage.setItem('hcc-language', nextLang)
    },
    changeCurrentPage(index) {
      // this.activeIndex = index
      switch (index) {
        case '1':
          this.$router.push('/home').catch(() => {})
          break
        case '2':
          this.$router.push('/about').catch(() => {})
          break
        case '2-1':
          this.$router.push('/production/1').catch(() => {})
          break
        case '2-2':
          this.$router.push('/production/2').catch(() => {})
          break
        case '2-3':
          this.$router.push('/production/3').catch(() => {})
          break
        case '2-4':
          this.$router.push('/production/4').catch(() => {})
          break
        case '3-0':
          this.$router.push('/portfolio-companies/0').catch(() => {})
          break
        case '3-1':
          this.$router.push('/portfolio-companies/1').catch(() => {})
          break
        case '3-2':
          this.$router.push('/portfolio-companies/2').catch(() => {})
          break
        case '3-3':
          this.$router.push('/portfolio-companies/3').catch(() => {})
          break
        case '3-4':
          this.$router.push('/portfolio-companies/4').catch(() => {})
          break
        case '4':
          this.$router.push('/four').catch(() => {})
          break
        case '4-1':
          this.$router.push('/fournav/1').catch(() => {})
          break
        case '4-2':
          this.$router.push('/fournav/2').catch(() => {})
          break
        case '4-3':
          this.$router.push('/fournav/3').catch(() => {})
          break
        case '5':
          window.open('http://www.hcccharitablefund.com', '_blank');
          break
        case '5-2':
          this.$router.push('/fivenav/2').catch(() => {})
          break
        case '5-3':
          this.$router.push('/fivenav/3').catch(() => {})
          break
        case '5-4':
          this.$router.push('/fivenav/2').catch(() => {})
          break
        case '6':
          this.$router.push('/seven').catch(() => {})
          break
        default:
          break
      }
    },
    changeOpen(index){
      console.log("index",index)
    }
  },
}
</script>

<style lang="scss" scoped>
.navbar_wrap {
  width: 100%;
  height: 70px;
  background: rgba(0,0,0,.25);
  //background: transparent;
  //backdrop-filter: saturate(180%) blur(0.5rem);
  box-shadow: 0 0.1rem 0.5rem rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  position: absolute;
  //top: 0;
  //left: 0;
  //right: 0;
  z-index: 1000;
  .navbar_container {
    width: 70%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media screen and (max-width: 1200px) {
      width: 100%;
    }
    .navbar_left {
      display: flex;
      align-items: center;
      height: 100%;
      img {
        width: 160px;
        cursor: pointer;
      }
    }
    .navbar_right {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 20px;
      a {
        text-decoration: none;
        color: #0038a4;
        display: inline-block;
        width: 100px;
        background: #ffa400;
        line-height: 27px;
        text-align: center;
        border-radius: 20px;
        padding: 5px;
      }
      .el_menu_demo {
        border: none;
      }
      .menu_item {
        &:hover {
          font-weight: 600;
          color: #ffa400 !important;
          //background: rgba(0,0,0,.3);
        }
      }
      .right_phone {
        &:hover {
          color: #ccc;
        }
        transition: all 0.5s;
        display: flex;
        align-items: center;
        i {
          font-size: 20px;
        }
        span {
          margin-left: 0.5rem;
        }
        margin-left: 2.5rem;
        color: #fff;
      }
    }

  }
  ::v-deep .el-menu-item{
    font-size: 1.1rem !important;
  }

  .menu_item{
    //background-color: rgba(0,0,0,.3) !important;
    font-size: 1.1rem !important;
  }

  ::v-deep ul{
    //background-color: rgba(0,0,0,.3) !important;
    font-size: 1.1rem !important;
  }

  ::v-deep .el-submenu__title{
    font-size: 1.1rem !important;
  }
}
</style>

<style lang="scss">
div.el-menu--horizontal{
  background-color: rgba(0,0,0,.3) !important;
  .el-menu-item:hover{
    color: #ffa400 !important;
    background-color: #fff !important;
  }
}
</style>
